<template>
    <div class="container">
        <div
            v-if="activity.generalStatus == 'completed'"
            :id="`${cellId}_completed`"
            tabindex="0"
            class="completed alert alert-secondary"
            role="alert"
            @click="openModal(activity)"
        >
            <span class="content"> {{ date.time }} {{ date.meridiem }} </span>
        </div>
        <div
            v-else-if="activity.generalStatus == 'overdue'"
            :id="`${cellId}_overdue`"
            tabindex="0"
            class="overdue alert alert-danger"
            role="alert"
            @click="openModal(activity)"
        >
            <span class="content"> {{ date.time }} {{ date.meridiem }} </span>
        </div>
        <div
            v-else-if="activity.generalStatus == 'active'"
            :id="`${cellId}_active`"
            tabindex="0"
            class="active alert alert-light border border-dark"
            role="alert"
            @click="openModal(activity)"
        >
            <span class="content"> {{ date.time }} {{ date.meridiem }} </span>
        </div>
    </div>
</template>
<script>
import ScheduleHelper from "../helper";
import TreatmentActivityMixin from "@/mixins/treatment-activity-details";

export default {
    name: "PatientTreatmentDetailsCard",
    mixins: [ScheduleHelper, TreatmentActivityMixin],
    props: {
        treatment: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        activity: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        cellId: {
            type: String,
            default: "cell"
        },
        cellDate: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        },
        prepareDateTime: {
            type: Function
        },
        parentRef: {
            type: HTMLDivElement,
            default() {
                return null;
            }
        }
    },
    data() {
        return {
            isChecked: true,
            date: {
                time: null,
                timeSimplify: null,
                hour: null,
                minute: null,
                meridiem: null,
                date: null,
                current: null,
                reference: null
            }
        };
    },
    watch: {
        activity: {
            handler(params) {
                if (params.referTime) {
                    // Convert the Unix timestamp to a DateTime object
                    let date = this._toDateTime(params.referTime);
                    date = this.prepareDateTime(date);
                    this.date = date;
                }
            },
            immediate: true // Trigger the handler on initial load
        }
    }
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    padding-right: 0;
    padding-left: 0;
}

.completed,
.overdue,
.active {
    display: flex;
    align-items: center;
    justify-content: center;
    width: -webkit-fill-available;
    height: 100%;
    border-radius: 0;
    cursor: pointer;
    margin-bottom: 0;
}

.completed {
    position: relative;
}

.content {
    display: flex;
    justify-content: center;
    flex: 1;
}
</style>
